import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { ShoppingBagIcon } from 'lucide-react';
import { offerAnchor } from '../data/content';
import { recentPurchases } from '../data/purchases';
const FIRST_DELAY = 6000;
const VISIBLE_FOR = 5000;
const INTERVAL = 12000;
export function PurchasePopup() {
  const [index, setIndex] = useState<number | null>(null);
  useEffect(() => {
    let count = 0;
    let hideTimer: number | undefined;
    let interval: number | undefined;
    const show = () => {
      setIndex(count % recentPurchases.length);
      count += 1;
      hideTimer = window.setTimeout(() => setIndex(null), VISIBLE_FOR);
    };
    const first = window.setTimeout(() => {
      show();
      interval = window.setInterval(show, INTERVAL);
    }, FIRST_DELAY);
    return () => {
      window.clearTimeout(first);
      window.clearTimeout(hideTimer);
      window.clearInterval(interval);
    };
  }, []);
  const purchase = index === null ? null : recentPurchases[index];
  return <div aria-live="polite" className="pointer-events-none fixed bottom-3 left-3 z-[60] md:bottom-6 md:left-6" data-id="element-219" data-mp="164oa074zg5up">
      <AnimatePresence data-id="element-220" data-mp="116cylrz1hnad">
        {purchase && <motion.a key={index} href={offerAnchor} initial={{
        opacity: 0,
        y: 16,
        scale: 0.96
      }} animate={{
        opacity: 1,
        y: 0,
        scale: 1
      }} exit={{
        opacity: 0,
        y: 16,
        scale: 0.96
      }} transition={{
        duration: 0.25,
        ease: [0.23, 1, 0.32, 1]
      }} className="pointer-events-auto flex w-[270px] items-center gap-3 rounded-xl border-[3px] border-brand bg-accent p-3 shadow-2xl shadow-brand-deep/50 ring-2 ring-white" data-id="element-221" data-mp="1fwbwdtmomwpb">
            <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-brand" data-id="element-222" data-mp="s5onb5116116">
              <ShoppingBagIcon className="h-5 w-5 text-white" aria-hidden="true" data-id="element-223" data-mp="28jy7ro25j5mq" />
            </span>
            <span className="min-w-0 text-left" data-id="element-224" data-mp="23m67o6rcsd7g">
              <span className="block text-sm font-extrabold leading-tight text-brand-deep" data-id="element-225" data-mp="23nhc88smhozm">
                {purchase.name}{' '}
                <span className="font-semibold" data-id="element-226" data-mp="2fne8rfc10qqr">
                  from {purchase.city}, {purchase.country}
                </span>
              </span>
              <span className="mt-0.5 block text-xs text-brand-deep" data-id="element-227" data-mp="2knacrekq4i6b">
                just purchased the Complete Lumbar Rehabilitation Bundle
              </span>
              <span className="mt-0.5 block text-[10px] font-black uppercase tracking-wider text-brand-deep/80" data-id="element-228" data-mp="1ryv0v0ww2fz7">
                {purchase.time}
              </span>
            </span>
          </motion.a>}
      </AnimatePresence>
    </div>;
}